import React from 'react';
import PropTypes from 'prop-types';

import { getThumbBySize } from '../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../constants/image-size-codes';
import HeadOpenGraphMeta from '../../../../components/global/HeadOpenGraphMeta';

const propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

const AllPhotosAccessLinkHandlerHeadMeta = ({ entity }) => {
  const coverPhoto = entity.cover_photo ?? entity.cover_photos?.records?.[0];

  const imageUrl = getThumbBySize(
    coverPhoto?.thumbnail_urls,
    IMAGE_SIZE_CODE.MEDIUM2X,
  )?.url;

  return <HeadOpenGraphMeta title={entity.name} imageUrl={imageUrl} />;
};

AllPhotosAccessLinkHandlerHeadMeta.propTypes = propTypes;

export default AllPhotosAccessLinkHandlerHeadMeta;
